import React from "react";
import crossIcon from "@/assets/icons/croosIcon.svg";

interface ModalProps {
    title?: string;
    positiveButtonText?: string;
    negativeButtonText?: string;
    desc?: string;
    isOpen: boolean;
    handleSaveChanges?: () => void;
    handleDiscardChanges?: () => void;
  }
export const LogoutModalComp: React.FC<ModalProps> = ({
    positiveButtonText,
    negativeButtonText,
    title,
    desc,
    isOpen,
    handleSaveChanges,
    handleDiscardChanges,
  }) => {
    return (
      <div
        className={`fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50 ${
          isOpen ? "" : "hidden"
        }`}
      >
        <div className="bg-white w-full max-w-md  rounded-lg shadow-lg">
          <div className="bg-p-gray flex justify-between py-4 px-8 rounded-t-2xl">
            <h2 className="font-semibold text-lg">
              {title ? title : "Unsaved Changes"}
            </h2>
            <button
              // className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
              onClick={handleSaveChanges}
            >
              <img src={crossIcon} className="w-6" />
            </button>
          </div>
          <div className="pt-3 pb-5 px-8">
  
          <p className="mb-4">{desc}</p>
          <div className="flex justify-end">
            {positiveButtonText && (
              <button
                onClick={handleSaveChanges}
                className="bg-primary-red mr-4 hover:bg-primary-red-button-hover text-white px-6 py-2 rounded-full focus:outline-none  "
              >
                {positiveButtonText}
              </button>
            )}
            {negativeButtonText && (
              <button
                onClick={handleDiscardChanges}
                className="bg-gray-300 text-gray-800 px-4 py-2 rounded-full focus:outline-none"
              >
                {negativeButtonText}
              </button>
            )}
          </div>
          </div>
        </div>
      </div>
    );
  };